/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-13 15:42:40
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-21 17:59:26
 * @FilePath: \baishu_react_ui\src\components\BsyDataManager\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";

import { BsyUtils } from "../../utils/Utils";
import BsyAlert from "../BsyAlert";
import BsyBatchEditPane from "../BsyBatchEditPane";
import BsyDataTable from "../BsyDataTable";
import BsyDialog from "../BsyDialog";
import BsyExportPane from "../BsyExportPane";
import BsyFieldSortPane from "../BsyFieldSortPane";
import BsyFilterPane from "../BsyFilterPane";
import BsyButton from "../BsyButton";
import BsyImportPane from "../BsyImportPane";
import BsyMsgBubble from "../BsyMsgBubble";

import { BsyWidget } from "../BsyWidget";

import "./index.css";
import BsyAlertMenu from "../BsyAlertMenu";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyBatchPrintPane from "../BsyBatchPrintPane";
import BsyExportFilePane from "../BsyExportFilePane";
import BsyBatchPrintQrcodePane from "../BsyBatchPrintQrcodePane";
import BsyBatchTransferPane from "../BsyBatchTransferPane";
import BsySlidePane from "../BsySlidePane";
import BsyDataManageRecycle from "../BsyDataManageRecycle";
import { BsyConfig } from "../../global/BsyConfig";
import BsyMaskLayer from "../BsyMaskLayer";
import BsySLoading from "../BsySLoading";
import BsySwitchBtn from "../BsySwitchBtn";
import BsySelect from "../BsySelect";
import BsySearchInput from "../BsySearchInput";
import { BatchActive } from "./BatchActive";

export default class BsyDataManage extends BsyWidget {
  static defaultProps = {
    url: "/data/_list",
    asyncExportURL: "/data/_list/excel_export",
    appId: "",
    entryId: "",
    formId: "",
    formName: "",
    formItems: [],
    formAttr: {},
    showFields: [],
    showFieldsFilter: null,
    showFieldsMeta: [],
    hasExtParams: !1,
    hasFlow: !1,
    dataPerms: {},
    isEtlTable: !1,
    optAuth: null,
    ignoreAuth: !1,
    authGroupId: null,
    // onDataFieldSelect: null,
    // onParamFieldSelect: null,
    // onDataFieldMetaChange: null,
    onSetAuth: null,
    hasDataRecycle: !1,
    printId: "system",
    hAdjust: 15,
    batchType: "", //delete 批量删除 edit 批量修改
    level2Menu: true,
    filterSticky: false,
    filterTopSticky: false,
    hasFilter: true,
    ignoreOptAuth: !1,
    ignoreValidate: !1,
    ptlist: [],
    selectDatas: [],
    isCheckAll: false,
    filter: null,
    is_dock_form: false,
    widgetId: null,
    enableRowEdit: false,
    quickEdit: false,
    printMethod: 1,
    batchPrintId: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      ...props,
      level2Menu: this.checkLevel2Menu(props),
      filterSticky:
        this.getFilterSticky(props.appId, props.entryId, props.authGroupId) ||
        false,
      filterTopSticky:
        this.getFilterTopSticky(
          props.appId,
          props.entryId,
          props.authGroupId
        ) || false,
      enableRowEdit: props.enableRowEdit || false,
      quickEdit: props.quickEdit || false,
      noRely: props.noRely || false,
    };
    if (props.filter) {
      this.filter = props.filter;
    }
    this.renderIndex = 0;
    this.bodyRef = React.createRef();
    this.batch_printRef = React.createRef();
    this.rel = props.rel;
    //
    this.isFlow = props.hasFlow && !props.hasCoop;
    this.fields = [];
    this.search = {
      fields: [],
      isSearchAllFields: true,
      keywords: [],
    };
    this.getSearchCach();
  }

  checkLevel2Menu = (props) => {
    if (props.ignoreAuth) {
      return true;
    }
    if (props.dataPerms) {
      if (props.dataPerms.batch_print) {
        return true;
      }
      if (props.dataPerms.export) {
        return true;
      }
      if (props.dataPerms.delete) {
        return true;
      }
      if (props.dataPerms.batch_update) {
        return true;
      }
    }

    return false;
  };

  getFilterCacheKey = () => {
    const { appId, entryId, authGroupId } = this.state;

    return BsyUtils.Store.getKey("filterValue", {
      appId: appId,
      entryId: entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  setFilterCache = (val) => {
    BsyUtils.Store.set(this.getFilterCacheKey(), val);
  };

  getFilterCache = () => {
    if (this.filter) return;
    let res = BsyUtils.Store.get(this.getFilterCacheKey());
    if (res) {
      this.rel = res.rel;
      this.filter = res.cond ? [...res.cond] : [];
    }
  };

  getFilterStickyKey = (appId1, entryId1, authGroupId1) => {
    // const { appId, entryId, authGroupId } = this.state;

    let appId, entryId, authGroupId;
    if (this.state) {
      appId = this.state.appId;
      entryId = this.state.entryId;
      authGroupId = this.state.authGroupId;
    }

    return BsyUtils.Store.getKey("filterSticky", {
      appId: appId1 || appId,
      entryId: entryId1 || entryId,
      authGroupId: BsyUtils.isNumber(authGroupId1 || authGroupId)
        ? authGroupId1 || authGroupId
        : "",
    });
  };
  getFilterTopStickyKey = (appId1, entryId1, authGroupId1) => {
    let appId, entryId, authGroupId;
    if (this.state) {
      appId = this.state.appId;
      entryId = this.state.entryId;
      authGroupId = this.state.authGroupId;
    }

    return BsyUtils.Store.getKey("filterTopSticky", {
      appId: appId1 || appId,
      entryId: entryId1 || entryId,
      authGroupId: BsyUtils.isNumber(authGroupId1 || authGroupId)
        ? authGroupId1 || authGroupId
        : "",
    });
  };

  setFilterTopSticky = (val) => {
    BsyUtils.Store.set(this.getFilterTopStickyKey(), val);
  };

  getFilterTopSticky = (appId, entryId, authGroupId) => {
    let res = BsyUtils.Store.get(
      this.getFilterTopStickyKey(appId, entryId, authGroupId)
    );
    return res;
  };

  setFilterSticky = (val) => {
    BsyUtils.Store.set(this.getFilterStickyKey(), val);
  };

  getFilterSticky = (appId, entryId, authGroupId) => {
    let res = BsyUtils.Store.get(
      this.getFilterStickyKey(appId, entryId, authGroupId)
    );
    return res;
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  _isFieldSelectable = (a) => {
    let b = this.options;
    return (
      !!a && (!b.optAuth || !(!b.optAuth[a.name] || !b.optAuth[a.name].visible))
    );
  };

  _getFields = (b) => {
    let c = this,
      d = this.options,
      e = [],
      f = ["label", "creator", "createTime", "updateTime", "_id"];
    if (d.hasFlow) {
      if (window.FX.STATIC.DECISION_SWITCH) {
        f.push("flowState", "flowdecision", "chargers");
      } else {
        f.push("flowState", "chargers");
      }
    }
    d.hasUserSource && f.push("ext");
    if (d.isEtlTable) {
      //如果是数据视图，则不需要系统字段
      f = [];
    }
    let g = [];
    let l = [];
    BsyUtils.forEach(f, function (a, b) {
      let e = BsyUtils.createEntryAttributeField(b, {
        entryId: d.entryId,
      });
      if (e.name === "label") {
        l.push(e);
      } else {
        c._isFieldSelectable(e) && g.push(e);
      }
    });

    BsyUtils.forEach(d.formItems, function (f, g) {
      let h = { ...g };
      h.formId = d.entryId;
      let i = BsyUtils.getFieldAttr(
        h,
        b || BsyConfig().LimitFields.list,
        d.quickEdit ? "manager" : ""
      );
      if (i && "separator" === i.type) {
        return;
      }

      if (c._isFieldSelectable(i)) {
        if ("subform" === i.type) {
          let j = [];
          BsyUtils.forEach(i.items, function (a, b) {
            c._isFieldSelectable({
              name: [i.name, b.name].join("."),
            }) && j.push(b);
          });
          i.items = j;
        }
        e.push(i);
      }
    });

    return l.concat(e.concat(g));
  };
  _getShowFields = (b, c) => {
    if (c && c.length > 0) {
      let d = [];
      BsyUtils.forEach(b, function (b, e) {
        let f = { ...e };
        if (c.indexOf(f.name) > -1) d.push(f);
        else if ("subform" === f.type) {
          let g = [];
          BsyUtils.forEach(f.items, function (a, b) {
            c.indexOf([f.name, b.name].join(".")) > -1 && g.push(b);
          });
          f.items = g;
          BsyUtils.isObjectEmpty(f.items) || d.push(f);
        }
      });
      return d;
    }
    return b;
  };

  getFilterConfig = () => {
    const {
      filterSticky,
      filterTopSticky,
      authGroupId,
      hasFlow,
      optAuth,
      ignoreAuth,
    } = this.state;
    this.getFilterCache();
    let extFields = [];
    if (hasFlow) {
      //chargers
      if (ignoreAuth || (optAuth["chargers"] && optAuth["chargers"].visible)) {
        extFields = [
          {
            id: this.state.entryId,
            name: "flownode",
            type: "flownode",
            text: React.language("flow.node.current"),
          },
          {
            id: this.state.entryId,
            name: "flow_chargers",
            type: "usergroup",
            text: React.language("flow.charger.current"),
          },
        ];
      }
    }
    return {
      hasRelation: true,
      hasPin: true,
      // hasHeader: filterSticky ? true : false,
      hasHeader: true,
      filterSticky,
      filterTopSticky,
      rel: this.rel || "and",
      cond: this.filter || [],
      authGroupId: authGroupId,
      entryList: {
        [this.state.entryId]: {
          id: this.state.entryId,
          name: this.state.formName,
          fields: [...this.fields, ...extFields],
        },
      },
      onFilterClose: () => {
        this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        this.setState(
          {
            filterSticky: false,
            filterTopSticky: false,
          },
          () => {
            this.setFilterSticky(this.state.filterSticky);
            this.setFilterTopSticky(this.state.filterTopSticky);
          }
        );
      },
      onFilterSticky: () => {
        const { filterSticky, filterTopSticky } = this.state;
        if (!filterSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }
        this.setState(
          {
            filterSticky: !filterSticky,
            filterTopSticky: !filterSticky ? false : filterTopSticky,
          },
          () => {
            this.setFilterSticky(this.state.filterSticky);
            this.setFilterTopSticky(this.state.filterTopSticky);
          }
        );
      },
      onFilterTopSticky: () => {
        const { filterTopSticky, filterSticky } = this.state;
        if (!filterTopSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }

        this.setState(
          {
            filterSticky: !filterTopSticky ? false : filterSticky,
            filterTopSticky: !filterTopSticky,
          },
          () => {
            this.setFilterSticky(this.state.filterSticky);
            this.setFilterTopSticky(this.state.filterTopSticky);
          }
        );
      },
      onSetFieldFilter: (val) => {
        this.rel = val.rel;
        this.filter = [...val.cond];
      },
      onFilter: (val, clearFilter) => {
        this.rel = val.rel;

        if (clearFilter) {
          this.filter = [];
        } else {
          this.filter = [...val.cond];
        }
        this.componentContext.reload({ skip: 0 });
        this.setFilterCache(val);
      },
    };
  };

  exportfile = (type, isAll, filter, idList) => {
    if (!BsyUtils.Vip.hasFileExport()) {
      BsyAlert({
        title: React.language("prompt1"),
        msg: React.language("tip.type"),
        type: "warning",
        text4Ok: React.language("vip.upgrade.yes"),
        text4Cancel: React.language("vip.upgrade.no"),
        onOk: function () {
          let routUrl = window.root_directroy
            ? window.root_directroy + "/"
            : "";
          BsyUtils.redirectTo(
            window._bby_config.site +
              routUrl +
              "index.php?bbymember/user_purchase_management"
          );
          return !1;
        },
      });
      return;
    }

    let that = this;
    let _opt = this.props;
    let config = {
      fields: that._getFields(),
      filter: filter,
      forms: [_opt.entryId],
      entryId: _opt.entryId,
      appId: _opt.appId,
      name: _opt.formName,
      idList: idList,
      filterMode: isAll,
      authGroupId: _opt.authGroupId,
    };
    BsyDialog({
      title: React.language("export.excel"),
      height: 440,
      width: 660,
      noFooter: true,
      onContentCreate: (e) => {
        return (
          <BsyExportFilePane
            {...config}
            onOk={(PostParam) => {
              e.closeAlter();
            }}
            onCancel={() => {
              e.closeAlter();
            }}
          />
        );
      },
    });
  };

  flowend = (datas, cb) => {
    const { appId, entryId } = this.state;
    let n = {
      appId: appId,
      entryId: entryId,
      formId: entryId,
      isCloseAll: !1,
      idList: datas,
    };

    React.axios(
      "/dashboard/app/" + appId + "/workflow/flow_batch_close",
      n
    ).then((res) => {
      BsyUtils.showAjaxTip(res.data, () => {
        let e, i;
        if (0 === res.data.total) {
          e = "warning";
          i = n.isCloseAll
            ? React.language("data.noFlow.inProgress")
            : React.language("data.noFlow.inProgress.selected");
        } else {
          e = "success";
          i = n.isCloseAll
            ? React.language("flow.close.all.done")
            : React.language("flow.close.selected.done");
          this.setState(
            {
              selectDatas: [],
            },
            () => {
              this.componentContext.reload({ skip: 0 });
            }
          );
        }
        tipAlert({
          type: e,
          msg: i,
        });
      });
    });
  };

  showFlowBatchActive = async () => {
    const { appId, entryId, ignoreAuth } = this.state;

    if (!ignoreAuth) {
      return true;
    }
    let datas = this.componentContext._getCheckData();
    if (datas && datas.length === 0) {
      tipAlert({
        type: "warning",
        msg: React.language("data.operation.select"),
      });
      return true;
    }

    let flowVers = [];
    BsyUtils.forEach(datas, (key, row) => {
      if (row.flowState === 1 || row.flowState === 2) {
        const ver = parseInt(row.flowVer);
        if (flowVers.indexOf(ver) === -1) {
          flowVers.push(ver);
        }
      }
    });
    if (flowVers.length === 0) {
      tipAlert({
        type: "warning",
        msg: React.language("no.operational.data"),
      });
      return true;
    }
    let layerRef = await BsyMaskLayer({
      customCls: "hasBackground",
      onContentCreate: (ref) => {
        // layerRef = ref;
        return (
          <div>
            <BsySLoading />
          </div>
        );
      },
    });
    // console.log(layerRef);
    try {
      const res = await React.axios("/data/workflow_list", {
        appId: appId,
        entryId: entryId,
        flowVers: flowVers,
      });
      let selectdata = [];
      let dlgRef = null;
      layerRef.close();
      layerRef = null;
      BsyDialog({
        title: React.language("flow.batch.active"),
        subTitle: React.language("flow.batch.active.subtitle"),
        height: 440,
        width: 500,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onContentCreate: (e) => {
          dlgRef = e;
          return (
            <BatchActive
              flowVers={Object.entries(res.data)}
              datas={datas}
              onStopEdit={(res) => {
                selectdata = res;
              }}
            />
          );
        },
        onOk: async (f) => {
          if (selectdata.length === 0) {
            tipAlert({
              type: "warning",
              msg: React.language("data.operation.select"),
            });
            return !1;
          }
          layerRef = await BsyMaskLayer({
            customCls: "hasBackground",
            onContentCreate: (ref) => {
              // layerRef = ref;
              return (
                <div>
                  <BsySLoading />
                </div>
              );
            },
          });
          const res = await React.axios(
            `/dashboard/app/${appId}/workflow/flow_batch_active`,
            {
              appId: appId,
              entryId: entryId,
              activeInfo: selectdata,
            }
          ); //
          // .then((res) => {
          dlgRef.close();
          layerRef.close();
          layerRef = null;
          this.componentContext.reload({ skip: 0 });
          BsyAlert({
            title: React.language("submit.finish"),
            msg: React.language("batch.forward.finish.tip", {
              success: res.data.success,
              fail: res.data.fail,
            }),
            type: "success",
            text4Ok: React.language("ok"),
            OkType: "blue",
            text4Cancel: "",
            ok: () => {
              return true;
            },
          });
          // });
          return !1;
        },
      });
    } catch (error) {
      console.log(error);
      layerRef?.close?.();
    }
  };

  // 权限组为0的时候，验证所选择的操作是否有效
  checkValiSelect = (optype, cb) => {
    const { authGroupId, selectDatas } = this.state;
    if (authGroupId !== 0) {
      cb && cb(selectDatas);
      return true;
    }
    if (selectDatas && selectDatas.length === 0) {
      cb && cb(selectDatas);
      return true;
    }

    let datas = this.componentContext._getCheckData();
    if (datas && datas.length === 0) {
      cb && cb(selectDatas);
      return true;
    }

    let newDatas = [];
    BsyUtils.forEach(datas, (key, row) => {
      if (row.dataPerms) {
        if (row.dataPerms[optype]) {
          newDatas.push(row._id);
        }
      } else {
        newDatas.push(row._id);
      }
    });

    if (newDatas.length === selectDatas.length) {
      cb && cb();
      return;
    }

    if (newDatas.length === 0) {
      this.setState(
        {
          selectDatas: [],
        },
        () => {
          // this.componentContext.reload()
          this.componentContext.AllCheckContext.setValue(false);
          BsyAlert({
            title: React.language("data.manager.not.permission"),
            type: "error",
            text4Ok: React.language("ok"),
            OkType: "red",
            ok: () => {},
          });
        }
      );

      return;
    }
    if (newDatas.length !== selectDatas.length) {
      this.setState(
        {
          selectDatas: newDatas,
        },
        () => {
          // this.componentContext.reload()
          this.componentContext.AllCheckContext.setValue(false);
          BsyAlert({
            title: React.language("data.manager.have.permission.data"),
            msg: React.language("data.manager.have.permission.data.tip", {
              total: selectDatas.length,
              select: newDatas.length,
            }),
            type: "warning",
            text4Ok: React.language("etl.doIt"),
            OkType: "red",
            text4Cancel: React.language("cancel"),
            ok: () => {
              cb && cb(newDatas);
            },
          });
        }
      );

      return;
    }
  };

  get_print_method = (e) => {
    this.setState({
      printMethod: e,
    });
  };

  get_batch_print_id = (e) => {
    this.setState({
      batchPrintId: e,
    });
  };

  hasSelectData = () => {
    let _opt = this.props;
    let that = this;
    const {
      ignoreAuth,
      dataPerms,
      selectDatas,
      printId,
      printMethod,
      batchPrintId,
    } = this.state;
    return (
      <div className={"select-datas-operation"}>
        <div
          className="operation-close"
          // style={{
          //   width: 30,
          //   minWidth: 30,
          //   marginLeft: 12,
          //   display: "flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   margin: "0 12px 0 6px",
          // }}
          onClick={(e) => {
            this.setState({ selectDatas: [] }, () => {
              that.componentContext.AllCheckContext.setValue(false);
            });
          }}
        >
          <i className="icon-bsy-close-small"></i>
        </div>
        <div class="total-cont">
          <span class="checked-num-wrapper">
            <span class="checked-title">已选</span>
            <span class="checked-num">{selectDatas.length}</span>/
            {this.componentContext.state.allCount}
          </span>
        </div>
        <div class="total-cont-split"></div>
        {(ignoreAuth || dataPerms.export) && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              this.checkValiSelect("export", (datas) => {
                this.operation("export", false, {}, datas || selectDatas);
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-bsy-reportmenu-7"></i>
              <span>{React.language("export")}</span>
            </div>
          </div>
        )}

        {(ignoreAuth || dataPerms.delete) && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              // this.operation('delete', false, {}, selectDatas)
              let typd = this.isFlow ? "flow_delete" : "delete";
              this.checkValiSelect(typd, (datas) => {
                this.operation(typd, false, {}, datas || selectDatas);
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-trasho "></i>
              <span>{React.language("delete")}</span>
            </div>
          </div>
        )}
        {(ignoreAuth || dataPerms.batch_update) && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              // this.operation('edit', false, {}, selectDatas)
              this.checkValiSelect("batch_update", (datas) => {
                this.operation(
                  "edit",
                  false,
                  that.componentContext.getFilterData(),
                  datas || selectDatas
                );
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-edit "></i>
              <span>{React.language("data.batch.edit")}</span>
            </div>
          </div>
        )}

        {ignoreAuth &&
          (window.FX.CONST.QN_BUCKET.UPLOAD_SITE === "qn" ||
            window.FX.CONST.QN_BUCKET.UPLOAD_SITE === "aliyun") && (
            <div
              className="BsyBtn"
              onClick={(e) => {
                this.operation("exportfile", false, {}, selectDatas);
              }}
            >
              <div className="btnCont">
                <i className="icon-batch-export "></i>
                <span>{React.language("data.batch.export.file")}</span>
              </div>
            </div>
          )}
        {ignoreAuth && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              this.operation("qrcode", false, {}, selectDatas);
            }}
          >
            <div className="btnCont">
              <i className="icon-qrcode "></i>
              <span>{React.language("data.batch.print.qrCode")}</span>
            </div>
          </div>
        )}

        {(ignoreAuth || (dataPerms.batch_print && printId !== "system")) && (
          <div
            ref={this.batch_printRef}
            className="BsyBtn"
            onClick={(e) => {
              that.checkValiSelect("batch_print", (datas) => {
                let menus = [];

                for (let index = 0; index < _opt.ptlist.length; index++) {
                  const element = _opt.ptlist[index];
                  if (element.printId === "system") {
                    continue;
                  }
                  menus.push({
                    text: element.name,
                    value: element.printId,
                  });
                }

                if (menus.length) {
                  BsyDialog({
                    title: React.language("print.batch"),
                    height: 460,
                    width: 520,
                    theme: this.props.theme,
                    okText: React.language("ok"),
                    cancelText: React.language("cancel"),
                    // noFooter: true,
                    onContentCreate: (e) => {
                      // let config = {
                      //   appId: _opt.appId,
                      //   entryId: _opt.formId || _opt.entryId,
                      //   fields: _opt.showFields,
                      //   authGroupId: _opt.authGroupId,
                      //   printId: element.printId,
                      //   dataList: that.selectDatas,
                      //   doPrint: true,
                      //   originPrint: _opt.originPrint,
                      //   extDashData: _opt.extDashData,
                      // }
                      return (
                        <div className="batch-print-pane">
                          <div className="data-num">
                            <i className="icon-print"></i>
                            <span>
                              {React.language("data.select", {
                                count: that.selectDatas.length,
                              })}
                            </span>
                          </div>
                          <div className="print-item">
                            <div className="item-label">
                              <span>
                                {React.language("data.printTemplate1")}
                              </span>
                              <b>*</b>
                            </div>
                            <div className="item-cont">
                              <BsySelect
                                allowBlank={false}
                                searchable={true}
                                minWidth={200}
                                onStopEdit={this.get_batch_print_id}
                                value={batchPrintId}
                                items={menus}
                              />
                            </div>
                          </div>
                          <div className="print-item">
                            <div className="item-label">
                              <span>{React.language("print.method")}</span>
                              <b>*</b>
                            </div>
                            <div className="item-cont">
                              <BsySelect
                                allowBlank={false}
                                searchable={false}
                                minWidth={200}
                                onStopEdit={this.get_print_method}
                                value={printMethod}
                                items={[
                                  {
                                    text: React.language("all.data.print"),
                                    tip: React.language("all.data.print.tip"),
                                    value: 1,
                                  },
                                  {
                                    text: React.language("one.data.print"),
                                    tip: React.language("one.data.print.tip"),
                                    value: 2,
                                  },
                                ]}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    },
                    onOk: () => {
                      if (!that.state.batchPrintId) {
                        tipAlert({
                          type: "warning",
                          msg: React.language("data.printTemplate1.tip"),
                        });
                        return false;
                      }

                      let config = {
                        appId: _opt.appId,
                        entryId: _opt.formId || _opt.entryId,
                        fields: _opt.showFields,
                        authGroupId: _opt.authGroupId,
                        printId: that.state.batchPrintId,
                        printMethod: that.state.printMethod,
                        dataList: that.selectDatas,
                        doPrint: true,
                        originPrint: _opt.originPrint,
                        extDashData: _opt.extDashData,
                      };

                      BsyDialog({
                        title: React.language("print.batch.log"),
                        height: 600,
                        width: 720,
                        noFooter: true,
                        onContentCreate: (e) => {
                          return <BsyBatchPrintPane {...config} />;
                        },
                      });
                    },
                  });
                  // BsyAlertMenu({
                  //   item: menus,
                  //   width: 150,
                  //   target: this.batch_printRef.current ? { target: this.batch_printRef.current } : e,
                  //   theme: this.props.theme,
                  //   customCls: ' data-manage-batch-menu ',
                  // })
                } else {
                  tipAlert({
                    type: "warning",
                    msg: React.language("vip.center.print.emptyTip"),
                  });
                }
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-batch-print"></i>
              <span>{React.language("print.batch")}</span>
            </div>
          </div>
        )}
        {ignoreAuth && _opt.hasFlow && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              that.checkValiSelect("flow_transfer", (datas) => {
                let config = {
                  appId: _opt.appId,
                  entryId: _opt.entryId,
                  formId: _opt.entryId,
                  authGroupId: _opt.authGroupId,
                  idList: datas || selectDatas,
                  isUpdateAll: !1,
                  filter: {},
                  onAfterUpdate: function () {
                    that.setState(
                      {
                        selectDatas: [],
                      },
                      () => {
                        that.componentContext.reload();
                        that.componentContext.AllCheckContext.setValue(false);
                      }
                    );
                  },
                };

                BsyDialog({
                  title: React.language("transfer.record"),
                  height: 470,
                  width: 560,
                  noFooter: true,
                  onContentCreate: (e) => {
                    return (
                      <BsyBatchTransferPane
                        {...config}
                        onOk={() => {}}
                        onCancel={() => {
                          e.closeAlter();
                        }}
                      />
                    );
                  },
                });
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-widget-user "></i>
              <span>{React.language("flow.transfer")}</span>
            </div>
          </div>
        )}
        {ignoreAuth && _opt.hasFlow && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              that.checkValiSelect("flow_close", (datas) => {
                BsyAlert({
                  title: React.language("flow.close.selected.confirm"),
                  msg:
                    React.language("form.data.select", {
                      length: (datas || selectDatas).length,
                    }) + React.language("flow.batch.close.tip"),
                  type: "warning",
                  text4Ok: React.language("ok"),
                  OkType: "blue",
                  text4Cancel: React.language("cancel"),
                  ok: () => {
                    that.flowend(datas || selectDatas);
                  },
                });
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-flow-end"></i>
              <span>{React.language("flow.close")}</span>
            </div>
          </div>
        )}
        {ignoreAuth && _opt.hasFlow && (
          <div className="BsyBtn" onClick={this.showFlowBatchActive}>
            <div className="btnCont">
              <i className="icon-new-piliangjihuo"></i>
              <span>{React.language("flow.batch.active")}</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  operation = (type, isAll, filter, idList) => {
    let _opt = this.props;
    let that = this;

    // if (!idList) {
    //   if (filter) {
    //     idList = this.componentContext.getAllDataId();
    //   }
    // } else {
    //   idList = idList || [];
    // }

    switch (type) {
      case "export": {
        let sort = this.componentContext.state.sort;

        if (Array.isArray(filter)) {
          filter = {
            cond: filter,
            rel: this.rel,
          };
        }
        let config = {
          fields: that._getFields(BsyConfig().LimitFields.excelExport),
          filter: filter,
          time: window.FX.STATIC.sitesetting.export_datatable_max_time,
          limit: window.FX.STATIC.sitesetting.export_datatable_max_num,
          forms: [_opt.entryId],
          entryId: _opt.entryId,
          sort: sort,
          appId: _opt.appId,
          is_dock_form: _opt.is_dock_form,
          name: _opt.formName,
          idList,
          authGroupId: _opt.authGroupId,
          extDashData: _opt.extDashData,
          showFields: this.componentContext.fields,
        };

        BsyDialog({
          title: React.language("export.excel"),
          height: "auto",
          width: 600,
          noFooter: true,
          onContentCreate: (e) => {
            return (
              <BsyExportPane
                {...config}
                onOk={(PostParam) => {
                  window.FX.Msg.notice({
                    title: React.language("export.excel.notice.title"),
                    type: "async",
                    duration: 0,
                    content: React.language("export.excel.notice.content"),
                  });
                  e.closeAlter();
                  React.axios("/data/_list/excel_export", PostParam)
                    .then((res) => {
                      if (res.data.code === 1) {
                        let e = window.$("<div />").append(
                          window.$("<p />").text(
                            React.language("export.excel.fileSuccess.content", {
                              name: _opt.formName,
                              time: BsyUtils.convertToRemainingTime(
                                (window.FX.STATIC.sitesetting
                                  .export_datatable_max_time || 1440) * 60,
                                "hour"
                              ),
                            })
                          )
                        );
                        e.append(
                          window
                            .$("<a href='javascript:void(0);' />")
                            .text(React.language("download.immediately"))
                            .on("click", function () {
                              BsyUtils.downloadFile2(
                                _opt.formName,
                                res.data.url
                              );
                              return false;
                            })
                        );
                        window.FX.Msg.notice({
                          title: React.language("export.excel.fileSuccess"),
                          type: "success",
                          duration: 0,
                          content: e,
                        });
                      } else {
                        window.FX.Msg.notice({
                          title: React.language("export.failTip"),
                          type: "error",
                          duration: 0,
                          content: res.data.msg,
                        });
                      }
                    })
                    .catch((res) => {
                      console.error(res);
                    });
                }}
                onCancel={() => {
                  e.closeAlter();
                }}
              />
            );
          },
        });

        break;
      }
      case "delete":
      case "flow_delete": {
        // extDashData:_opt.extDashData

        switch (isAll) {
          case "all": {
            BsyAlert({
              title: React.language("want.delete.form.data", {
                name: this.state.formName,
              }),
              type: "warning",
              text4Ok: React.language("delete"),
              OkType: "red",
              text4Cancel: React.language("cancel"),
              ok: () => {
                this.componentContext.BBY_doDeleteData(
                  [],
                  true,
                  null,
                  _opt.extDashData
                );
                this.componentContext.AllCheckContext.setValue(false);
                this.setState({
                  selectDatas: [],
                });
              },
            });
            break;
          }
          case "filter": {
            BsyAlert({
              title: React.language("filter.delete.data", {
                num: this.componentContext.state.filterCount,
              }),
              type: "warning",
              text4Ok: React.language("delete"),
              OkType: "red",
              text4Cancel: React.language("cancel"),
              ok: () => {
                this.setState(
                  {
                    selectDatas: [],
                  },
                  () => {
                    this.componentContext.BBY_doDeleteData(
                      [],
                      false,
                      filter,
                      _opt.extDashData
                    );
                    this.componentContext.AllCheckContext.setValue(false);
                  }
                );
              },
            });
            break;
          }
          default: {
            BsyAlert({
              title: React.language("select.delete.data", {
                num: idList.length,
              }),
              type: "warning",
              text4Ok: React.language("delete"),
              OkType: "red",
              text4Cancel: React.language("cancel"),
              ok: () => {
                this.setState(
                  {
                    selectDatas: [],
                  },
                  () => {
                    this.componentContext.BBY_doDeleteData(
                      idList,
                      false,
                      {},
                      _opt.extDashData
                    );
                    this.componentContext.AllCheckContext.setValue(false);
                  }
                );
              },
            });
          }
        }

        break;
      }
      case "edit": {
        let config = {
          appId: _opt.appId,
          entryId: _opt.entryId,
          formId: _opt.entryId,
          fields: _opt.formItems,
          authGroupId: _opt.authGroupId,
          optAuth: _opt.optAuth,
          ignoreAuth: _opt.ignoreAuth,
          is_dock_form: _opt.is_dock_form,
          idList: idList,
          isUpdateAll: false,
          filter: filter,
          extDashData: _opt.extDashData,
          onAfterUpdate: function () {
            that.setState(
              {
                selectDatas: [],
              },
              () => {
                that.componentContext.reload();
                that.componentContext.AllCheckContext.setValue(false);
              }
            );
          },
        };
        switch (isAll) {
          case "all": {
            config = {
              appId: _opt.appId,
              entryId: _opt.entryId,
              formId: _opt.entryId,
              fields: _opt.formItems,
              authGroupId: _opt.authGroupId,
              is_dock_form: _opt.is_dock_form,
              optAuth: _opt.optAuth,
              ignoreAuth: _opt.ignoreAuth,
              idList: undefined,
              isUpdateAll: true,
              extDashData: _opt.extDashData,
              filter: {}, //this.componentContext.getFilterData(),
              onAfterUpdate: function () {
                that.setState(
                  {
                    selectDatas: [],
                  },
                  () => {
                    that.componentContext.reload();
                    that.componentContext.AllCheckContext.setValue(false);
                  }
                );
              },
            };
            break;
          }
          case "filter": {
            config = {
              appId: _opt.appId,
              entryId: _opt.entryId,
              formId: _opt.entryId,
              fields: _opt.formItems,
              authGroupId: _opt.authGroupId,
              optAuth: _opt.optAuth,
              is_dock_form: _opt.is_dock_form,
              ignoreAuth: _opt.ignoreAuth,
              idList: undefined,
              isUpdateAll: true,
              filter: filter,
              extDashData: _opt.extDashData,
              onAfterUpdate: function () {
                that.setState(
                  {
                    selectDatas: [],
                  },
                  () => {
                    that.componentContext.reload();
                    that.componentContext.AllCheckContext.setValue(false);
                  }
                );
              },
            };
            break;
          }
          default: {
            let fieldItems = [];

            if (_opt.authGroupId === 0) {
              let viewField = {};
              let selectd = that.componentContext._getCheckData();
              for (let i = 0; i < selectd.length; i++) {
                let element = selectd[i];
                if (element.dataPerms.batch_update) {
                  BsyUtils.forEach(element.optAuth, function (a, b) {
                    if (!viewField.hasOwnProperty(a)) {
                      viewField[a] = true;
                    }
                    if (viewField[a]) {
                      viewField[a] = b.enable;
                    }
                  });
                }
              }

              for (let i = 0; i < _opt.formItems.length; i++) {
                let element = _opt.formItems[i];
                if (viewField[element.widget.widgetName]) {
                  if (element.widget.type === "subform") {
                    let subform = {
                      ...element,
                    };
                    let subitems = [...element.widget.items];
                    var item = [];
                    for (let j = 0; j < subitems.length; j++) {
                      if (viewField[subitems[j].widget.widgetName]) {
                        item.push([...subitems[j]]);
                      }
                    }
                    if (item.length > 0) {
                      subform.items = [...item];
                      fieldItems.push({
                        ...subform,
                      });
                    }
                  } else {
                    fieldItems.push({
                      ...element,
                    });
                  }
                }
              }
            } else {
              fieldItems = [..._opt.formItems];
            }
            config = {
              appId: _opt.appId,
              entryId: _opt.entryId,
              formId: _opt.entryId,
              fields: fieldItems,
              authGroupId: _opt.authGroupId,
              optAuth: _opt.optAuth,
              ignoreAuth: _opt.ignoreAuth,
              is_dock_form: _opt.is_dock_form,
              idList: idList,
              isUpdateAll: false,
              filter: filter,
              extDashData: _opt.extDashData,
              onAfterUpdate: function () {
                that.setState(
                  {
                    selectDatas: [],
                  },
                  () => {
                    that.componentContext.reload();
                    that.componentContext.AllCheckContext.setValue(false);
                  }
                );
              },
            };
          }
        }

        BsyDialog({
          title: React.language("data.batch.edit"),
          subTitle: React.language("data.batch.edit.subtitle", {
            len:
              idList && idList.length
                ? idList.length
                : isAll === "all"
                ? this.componentContext.state.allCount
                : this.componentContext.state.filterCount,
          }),
          height: 470,
          width: 560,
          noFooter: true,
          onContentCreate: (e) => {
            return (
              <BsyBatchEditPane
                {...config}
                onOk={() => {}}
                onCancel={() => {
                  e.closeAlter();
                }}
              />
            );
          },
        });
        break;
      }
      case "exportfile": {
        this.exportfile(type, isAll, filter, idList);
        break;
      }
      case "qrcode": {
        React.axios(`/data/batch_qr_allcheck`, {
          filter:
            isAll === "all" ? {} : isAll === "filter" ? filter : undefined,
          idList:
            isAll === "all"
              ? undefined
              : isAll === "filter"
              ? undefined
              : idList,
          jsplatform: "React",
        }).then((res) => {
          let config = {
            appId: _opt.appId,
            entryId: _opt.entryId,
            formId: _opt.entryId,
            fields: that._getFields(),
            sort: that.componentContext.state.sort,
            authGroupId: _opt.authGroupId,
            optAuth: _opt.optAuth,
            ignoreAuth: _opt.ignoreAuth,
            formName: _opt.formName,
            idList: that.selectDatas,
            isPrintAll: isAll === "all",
            filter: isAll === "filter" ? filter : {},
          };

          BsyDialog({
            title: React.language("print.paper.set"),
            height: 520,
            width: 600,
            noFooter: true,
            onContentCreate: (e) => {
              return (
                <BsyBatchPrintQrcodePane
                  {...config}
                  onOk={() => {}}
                  onCancel={() => {
                    e.closeAlter();
                  }}
                />
              );
            },
          });
        });
        break;
      }
      default: {
      }
    }
  };

  operationPane = (event, type) => {
    let filter = this.componentContext.getFilterData();
    let bts = [
      {
        icon: "",
        name: React.language("data.manager.filterdata.edit"),
        type: "filter",
        customCls: BsyUtils.isObjectEmpty(filter) ? " bsy-ui-disable" : "",
      },
      {
        icon: "",
        name: React.language("data.manager.alldata.edit"),
        type: "all",
        customCls: "",
      },
    ];
    let menus = [];

    for (let index = 0; index < bts.length; index++) {
      const element = bts[index];
      menus.push({
        text: element.name,
        icon: element.icon,
        customCls: element.customCls,
        click: () => {
          this.operation(type, element.type, filter);
        },
      });
    }
    BsyAlertMenu({
      item: menus,
      width: 150,
      target: event.target,
      theme: this.props.theme,
      customCls: " data-manage-batch-menu ",
    });
  };

  renderHeaderMenu = () => {
    const {
      ignoreAuth,
      dataPerms,
      hasDataRecycle,
      selectDatas,
      quickEdit,
      noRely,
    } = this.state;
    let _opt = this.props;
    let that = this;

    if (selectDatas.length) {
      return this.hasSelectData();
    }

    return (
      <>
        {(ignoreAuth || dataPerms.create || dataPerms.flow_create) && (
          <BsyButton
            text={React.language("create")}
            iconName={"icon-bsy-add"}
            height={30}
            click={() => {
              this.componentContext.create();
            }}
            mode={window.mode + " add "}
          />
        )}
        {(ignoreAuth || dataPerms.import) && (
          <BsyButton
            text={React.language("import")}
            height={30}
            iconName={"icon-vip-center-excel-import"}
            click={() => {
              let sort = this.componentContext.state.sort;
              let config = {
                fields: that._getFields(BsyConfig().LimitFields.excelExport),
                filter: this.componentContext.getFilterData(),
                // time: window.FX.STATIC.sitesetting?.export_datatable_max_time || 1440,
                // limit: window.FX.STATIC.sitesetting?.export_datatable_max_num || 1000,
                forms: [_opt.entryId],
                entryId: _opt.entryId,
                sort: sort,
                hasFlow: _opt.hasFlow,
                is_dock_form: _opt.is_dock_form,
                appId: _opt.appId,
                name: _opt.formName,
                authGroupId: _opt.authGroupId,
                formItems: _opt.formItems,
                ignoreAuth: _opt.ignoreAuth,
                extDashData: _opt.extDashData,
                onFinish: () => {
                  this.componentContext.reload({ skip: 0 });
                },
              };

              BsyDialog({
                title: React.language("import.excel"),
                height: 600,
                width: 966,
                noFooter: true,
                onContentCreate: (e) => {
                  return (
                    <BsyImportPane
                      {...config}
                      onClost={() => {
                        e.closeAlter();
                      }}
                    />
                  );
                },
              });
            }}
            mode={window.mode}
          />
        )}
        {(ignoreAuth || dataPerms.export) && (
          <div
            className="BsyBtn"
            onClick={(e) => {
              if (!BsyUtils.isObjectEmpty(this.props.extDashData)) {
                this.operation("export", false, this.props.filter, []);
                return;
              }

              this.operationPane(e, "export");
            }}
          >
            <div className="btnCont">
              <i className="icon-bsy-reportmenu-7"></i>
              <span>{React.language("export")}</span>
              <i
                className="icon-bby-xiala"
                style={{
                  margin: 0,
                }}
              ></i>
            </div>
          </div>
        )}

        {(ignoreAuth || dataPerms.delete || dataPerms.flow_delete) &&
          BsyUtils.isObjectEmpty(this.props.extDashData) && (
            <div
              className="BsyBtn"
              onClick={(e) => {
                this.operationPane(e, "delete");
              }}
            >
              <div className="btnCont">
                <i className="icon-trasho "></i>
                <span>{React.language("delete")}</span>
                <i
                  className="icon-bby-xiala"
                  style={{
                    margin: 0,
                  }}
                ></i>
              </div>
            </div>
          )}
        {ignoreAuth && (
          <div
            className="BsyBtn"
            onClick={(event) => {
              // this.operationPane(event, "edit")

              let filter = this.componentContext.getFilterData();
              let bts = [
                {
                  icon: "icon-edit",
                  name: React.language("data.batch.edit"),
                  type: "edit",
                },
                {
                  icon: "icon-qrcode",
                  name: React.language("data.batch.print.qrCode"),
                  type: "qrcode",
                },
              ];

              switch (window.FX.CONST.QN_BUCKET.UPLOAD_SITE) {
                case "qn":
                case "aliyun": {
                  bts = [
                    {
                      icon: "icon-edit",
                      name: React.language("data.batch.edit"),
                      type: "edit",
                    },
                    {
                      icon: "icon-batch-export",
                      name: React.language("data.batch.export.file"),
                      type: "exportfile",
                    },
                    {
                      icon: "icon-qrcode",
                      name: React.language("data.batch.print.qrCode"),
                      type: "qrcode",
                    },
                  ];
                  break;
                }
                default: {
                  break;
                }
              }

              if (dataPerms.batch_update) {
                bts = [
                  {
                    icon: "icon-edit",
                    name: React.language("data.batch.edit"),
                    type: "edit",
                  },
                ];
              }

              let menus = [];

              for (let index = 0; index < bts.length; index++) {
                const element = bts[index];
                menus.push({
                  text: element.name,
                  icon: element.icon,
                  extIcon: "icon-bsy-right",
                  click: () => {},
                  onMouseEnter: (e) => {
                    if (this.floatMenuContext) {
                      this.floatMenuContext.closeAlter();
                      this.floatMenuContext = null;
                    }

                    BsyMsgBubble({
                      anchor: e.currentTarget,
                      contentHTML: (ref) => {
                        this.floatMenuContext = ref;
                        return (
                          <div className="BsyAlertMenu " style={{ width: 200 }}>
                            <div className="alertMenuContent">
                              <div className="content data-manage-batch-menu ">
                                <div
                                  className={
                                    "item " +
                                    (BsyUtils.isObjectEmpty(filter)
                                      ? "bsy-ui-disable"
                                      : "")
                                  }
                                  onClick={() => {
                                    this.operation(
                                      element.type,
                                      "filter",
                                      filter
                                    );
                                  }}
                                >
                                  <span>
                                    {React.language(
                                      "data.manager.filterdata." + element.type
                                    )}
                                  </span>
                                </div>
                                <div
                                  className="item "
                                  onClick={() => {
                                    this.operation(element.type, "all", {});
                                  }}
                                >
                                  <span>
                                    {React.language(
                                      "data.manager.alldata." + element.type
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      },
                      text4Cancel: null,
                      text4Ok: null,
                      theme: that.props.theme,
                      minWidth: "auto",
                      width: 350,
                      contentPadding: 0,
                      edge: 200,
                      hAdjust: 72,
                      leftOffset: 170,
                      topOffset: -40,
                      dockPosition: "left",
                      onClose: function () {
                        // that.setState({

                        // })
                        return !1;
                      },
                    });
                  },
                  onMouseLeave: (e) => {},
                });
              }

              BsyAlertMenu({
                item: menus,
                width: 180,
                target: event.target,
                theme: this.props.theme,
                customCls: " data-manage-batch-menu ",
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-batch-edit "></i>
              <span>{React.language("batchOperation")}</span>
              <i
                className="icon-bby-xiala"
                style={{
                  margin: 0,
                }}
              ></i>
            </div>
          </div>
        )}
        {dataPerms.batch_update &&
          BsyUtils.isObjectEmpty(this.props.extDashData) && (
            <div
              className="BsyBtn"
              onClick={(event) => {
                this.operationPane(event, "edit");
              }}
            >
              <div className="btnCont">
                <i className="icon-batch-edit "></i>
                <span>{React.language("data.batch.edit")}</span>
                <i
                  className="icon-bby-xiala"
                  style={{
                    margin: 0,
                  }}
                ></i>
              </div>
            </div>
          )}
        {(ignoreAuth ||
          dataPerms.batch_update ||
          dataPerms.batch_print ||
          (ignoreAuth && _opt.hasFlow)) && (
          <div
            className="BsyBtn"
            onClick={(event) => {
              let bts = [];
              if (ignoreAuth || dataPerms.batch_update) {
                bts.push({
                  icon: "icon-edit",
                  name: React.language("data.batch.edit"),
                  type: "edit",
                  click: () => {
                    let config = {
                      appId: _opt.appId,
                      entryId: _opt.entryId,
                      formId: _opt.entryId,
                      fields: _opt.formItems,
                      authGroupId: _opt.authGroupId,
                      optAuth: _opt.optAuth,
                      is_dock_form: _opt.is_dock_form,
                      ignoreAuth: _opt.ignoreAuth,
                      showMode: "showlog",
                      isUpdateAll: false,
                      extDashData: _opt.extDashData,
                    };

                    BsyDialog({
                      title: React.language("data.batch.edit"),
                      subTitle: "",
                      height: 470,
                      width: 560,
                      noFooter: true,
                      onContentCreate: (e) => {
                        return (
                          <BsyBatchEditPane
                            {...config}
                            onOk={() => {}}
                            onCancel={() => {
                              e.closeAlter();
                            }}
                          />
                        );
                      },
                    });
                  },
                });
              }

              if (ignoreAuth && _opt.hasFlow) {
                bts.push({
                  icon: "icon-widget-user",
                  name: React.language("flow.transfer"),
                  type: "flow.transfer",
                  click: () => {
                    let config = {
                      appId: _opt.appId,
                      entryId: _opt.entryId,
                      formId: _opt.entryId,
                      authGroupId: _opt.authGroupId,
                      is_dock_form: _opt.is_dock_form,
                      showMode: "showlog",
                      isUpdateAll: !1,
                      filter: {},
                    };

                    BsyDialog({
                      title: React.language("transfer.record"),
                      height: 470,
                      width: 560,
                      noFooter: true,
                      onContentCreate: (e) => {
                        return (
                          <BsyBatchTransferPane
                            {...config}
                            onOk={() => {}}
                            onCancel={() => {
                              e.closeAlter();
                            }}
                          />
                        );
                      },
                    });
                  },
                });
              }

              //合并权限不显示
              if (ignoreAuth || dataPerms.batch_print) {
                bts.push({
                  icon: "icon-batch-export",
                  name: React.language("print.batch.log"),
                  type: "print_batch",
                  click: () => {
                    let config = {
                      appId: _opt.appId,
                      entryId: _opt.formId || _opt.entryId,
                      fields: _opt.showFields,
                      authGroupId: _opt.authGroupId,
                      is_dock_form: _opt.is_dock_form,
                      dataList: that.selectDatas,
                      doPrint: false,
                      originPrint: _opt.originPrint,
                      extDashData: _opt.extDashData,
                    };

                    BsyDialog({
                      title: React.language("print.batch"),
                      height: 600,
                      width: 720,
                      noFooter: true,
                      onContentCreate: (e) => {
                        return <BsyBatchPrintPane {...config} />;
                      },
                    });
                  },
                });
              }

              let menus = [];

              for (let index = 0; index < bts.length; index++) {
                const element = bts[index];
                menus.push({
                  text: element.name,
                  icon: element.icon,
                  click: element.click,
                });
              }

              BsyAlertMenu({
                item: menus,
                width: 180,
                target: event.target,
                theme: this.props.theme,
                customCls: " data-manage-batch-menu ",
              });
            }}
          >
            <div className="btnCont">
              <i className="icon-bsy-operation-record "></i>
              <span>{React.language("data.operation.record")}</span>
              <i
                className="icon-bby-xiala"
                style={{
                  margin: 0,
                }}
              ></i>
            </div>
          </div>
        )}

        {hasDataRecycle && (
          <BsyButton
            text={React.language("vip.center.dataBackup")}
            height={30}
            iconName={"icon-bby-shujuhuishou"}
            click={() => {
              if (!BsyUtils.Vip.hasDataBackup()) {
                BsyUtils.Vip.showUpgradeTip({
                  msg: React.language("error.7121"),
                  code: 7194,
                });
                return;
              }

              let recycleConfig = { ...this.props };
              recycleConfig.optAuth = null;
              // recycleConfig.fields.push({
              //   name: "deleter",
              //   type: "user",
              //   text: React.language("field.deleter")
              // })
              // recycleConfig.fields.push({
              //   name: "deleteTime",
              //   type: "datetime",
              //   format: "yyyy-MM-dd HH:mm:ss",
              //   text: React.language("field.deleteTime")
              // })

              BsySlidePane({
                title: React.language("vip.center.dataBackup"),
                hasHeader: true,
                onContentCreate: (ref) => {
                  window.FX.STATIC.isBackup = true;
                  return <BsyDataManageRecycle {...recycleConfig} />;
                },
                onClose: () => {
                  this.componentContext.reload({ skip: 0 });
                  window.FX.STATIC.isBackup = null;
                  return true;
                },
              });
            }}
            mode={window.mode}
          />
        )}

        {quickEdit && ignoreAuth ? (
          <>
            <span className="split-line"></span>
            <div className="BsyBtnSwitch">
              <div className="SwitchBtn">
                <BsySwitchBtn power={noRely} switchChange={this.switchChange} />
              </div>
              <span className={"BsyBtnSwitch-title"}>
                {React.language("qickedit")}
              </span>
              <i
                onMouseEnter={(e) => {
                  if (window.FX && window.FX.UI) {
                    window.FX.UI.showPopover({
                      position: "top",
                      anchor: window.$(e.currentTarget),
                      content: window
                        .$("<span />")
                        .text(React.language("data.manager.qickedit")),
                      // type: "dark"
                    });
                  }
                }}
                onMouseLeave={() => {
                  if (window.FX && window.FX.UI) {
                    window.FX.UI.closePopover();
                  }
                }}
                className="icon-bsy-help"
              ></i>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  switchChange = (power) => {
    this.componentKey = "table" + this.renderIndex++;
    this.setState(
      {
        noRely: power,
      },
      () => {
        this.setNoRelyCache(power);
      }
    );
  };

  onGetFilterPaneContext = (context) => {
    this.filterPaneContext = context;
  };

  createHeader = () => {
    const { filterSticky, filterTopSticky, selectDatas } = this.state;
    let _opt = this.props;
    let key = "menu" + this.renderIndex++;
    let that = this;
    return (
      <div className="bsy-data-manage-block-head">
        <div
          className={`block-menu ${selectDatas.length ? "select" : ""}`}
          key={key}
        >
          {this.renderHeaderMenu()}
        </div>
        <div
          className="block-menu-right"
          style={{
            display: selectDatas.length ? "none" : "flex",
          }}
        >
          {
            <BsySearchInput
              placeholder={React.language("search.data")}
              styleInput={{
                width: "200px",
              }}
              onSearch={(val) => {
                if (val) {
                  this.search.keywords = [val];
                } else {
                  this.search.keywords = [];
                }
                this.onSearchText();
              }}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
              onExtElement={() => {
                return (
                  <>
                    <i onClick={this.onSearchFields} className="icon-bsy-xia" />
                  </>
                );
              }}
            ></BsySearchInput>
          }
          {!filterSticky && !filterTopSticky ? (
            this.props.hasFilter ? (
              <BsyButton
                onMouseEnter={(event) => {
                  window.FX.UI.showPopover({
                    position: "bottom",
                    anchor: window.$(event.target),
                    content: window
                      .$("<span/>")
                      .text(React.language("filter.condition")),
                    type: "dark",
                  });
                }}
                onMouseLeave={(e) => {
                  window.FX.UI.closePopover();
                }}
                tip={React.language("filter.condition")}
                iconName={"icon-bsy-shaixuananniu"}
                click={(e) => {
                  let config = this.getFilterConfig();
                  console.log(config);
                  BsyMsgBubble({
                    anchor: e.currentTarget,
                    customCls: "filter-bubble",
                    onGetContext: this.onGetFilterPaneContext,
                    contentHTML: (ref) => {
                      return (
                        <BsyFilterPane
                          {...config}
                          hasSticky={true}
                        ></BsyFilterPane>
                      );
                    },
                    text4Cancel: null,
                    text4Ok: null,
                    theme: this.props.theme,
                    minWidth: "auto",
                    width: 350,
                    contentPadding: 0,
                    edge: 200,
                    hAdjust: 72,
                    dockPosition: "right",
                    onClose: function () {
                      that.setState({});
                      return !1;
                    },
                  });
                }}
                mode={window.mode}
              />
            ) : (
              ""
            )
          ) : (
            ""
          )}
          {
            <BsyButton
              onMouseEnter={(event) => {
                window.FX.UI.showPopover({
                  position: "bottom",
                  anchor: window.$(event.target),
                  content: window.$("<span/>").text(React.language("refresh")),
                  type: "dark",
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
              tip={React.language("refresh")}
              iconName={"icon-async"}
              click={() => {
                this.componentContext.reload();
              }}
              mode={window.mode}
            />
          }
          {
            <BsyButton
              onMouseEnter={(event) => {
                window.FX.UI.showPopover({
                  position: "bottom",
                  anchor: window.$(event.target),
                  content: window.$("<span/>").text(React.language("sort")),
                  type: "dark",
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
              tip={React.language("sort")}
              type={
                that.componentContext &&
                !BsyUtils.isObjectEmpty(that.componentContext.state.sort)
                  ? "hover"
                  : ""
              }
              iconName={"icon-bsy-iconpaixu"}
              click={(e) => {
                // this.componentContext.BBY_doSetFields(e)

                let config = {
                  appId: _opt.appId,
                  entryId: _opt.entryId,
                  formId: _opt.entryId,
                  name: that.state.formName,
                  entryList: {
                    [that.state.entryId]: {
                      id: that.state.entryId,
                      name: that.state.formName,
                      fields: [...that.fields],
                    },
                  },
                  sort: that.componentContext.state.sort,
                };

                BsyMsgBubble({
                  anchor: e.currentTarget,
                  contentHTML: (ref) => {
                    return (
                      <BsyFieldSortPane
                        {...config}
                        onSort={(sort) => {
                          that.componentContext.reload({
                            skip: 0, //??? 是否要回到首页
                            sort: [...sort],
                          });
                          ref.closeAlter();
                        }}
                      ></BsyFieldSortPane>
                    );
                  },
                  text4Cancel: null,
                  text4Ok: null,
                  theme: that.props.theme,
                  minWidth: "auto",
                  width: 350,
                  contentPadding: 0,
                  edge: 200,
                  hAdjust: 72,
                  dockPosition: "right",
                  onClose: function () {
                    // that.setState({

                    // })
                    return !1;
                  },
                });
              }}
              mode={window.mode}
            />
          }
          {
            <BsyButton
              onMouseEnter={(event) => {
                window.FX.UI.showPopover({
                  position: "bottom",
                  anchor: window.$(event.target),
                  content: window
                    .$("<span/>")
                    .text(React.language("field.show")),
                  type: "dark",
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
              // text={React.language("field.show")}
              tip={React.language("field.show")}
              iconName={"icon-page-view"}
              click={(e) => {
                this.componentContext.BBY_doSetFields(e);
              }}
              mode={window.mode}
            />
          }

          {
            <BsyButton
              onMouseEnter={(event) => {
                window.FX.UI.showPopover({
                  position: "bottom",
                  anchor: window.$(event.target),
                  content: window
                    .$("<span/>")
                    .text(
                      !event.currentTarget
                        .querySelector("i")
                        .classList.contains("icon-shrink")
                        ? "放大"
                        : "缩小"
                    ),
                  type: "dark",
                });
              }}
              onMouseLeave={(e) => {
                window.FX.UI.closePopover();
              }}
              iconName={"icon-enlarge"}
              click={(e) => {
                if (this.bodyRef.current) {
                  this.bodyRef.current.classList.toggle("manage-fullscreen");
                  e.currentTarget
                    .querySelector("i")
                    .classList.toggle("icon-shrink");
                  if (
                    this.bodyRef.current.classList.contains("manage-fullscreen")
                  ) {
                    this.bodyRef.current.style.height = "100%";
                    this.bodyRef.current.style.paddingTop = "6px";
                  } else {
                    this.bodyRef.current.style.height = "calc(100% - 20px)";
                    this.bodyRef.current.style.paddingTop = "";
                  }

                  const brot = BsyUtils.closestClass(
                    this.element.current,
                    "bsy-frame-content"
                  );
                  if (brot) {
                    const leftMenu = document.querySelector(".bsy-frame-menu");
                    if (leftMenu) {
                      leftMenu.style.display =
                        this.bodyRef.current.classList.contains(
                          "manage-fullscreen"
                        )
                          ? "none"
                          : "";
                    }
                  }
                }
              }}
              mode={window.mode}
            />
          }
        </div>
      </div>
    );
  };

  onSearchText = () => {
    let that = this;
    if (this.search.keywords && this.search.keywords.length) {
      if (this.componentContext.state.allCount > 10000) {
        if (this.search.isSearchAllFields == true) {
          this.search.isSearchAllFields = false;

          let n = 5;
          if (this.search.fields.indexOf("label") > -1) {
            n = 6;
          }

          if (this.search.fields.length == 0) {
            n = 6;
          }

          BsyUtils.forEach(this.fields, (a1, b1) => {
            if (that.search.fields.length >= n) {
              return false;
            }
            if (that.search.fields.indexOf(b1.name) == -1) {
              that.search.fields.push(b1.name);
            }
          });
        }
      }

      this.componentContext.reload({
        search: this.search,
        skip: 0,
      });
    } else {
      this.componentContext.reload({ search: null, skip: 0 });
    }
  };

  onSearchFields = (event) => {
    this.showCombo(event.currentTarget);
  };

  getNoRelyCacheKey = () => {
    const { appId, entryId, authGroupId } = this.state;
    return BsyUtils.Store.getKey("noRely", {
      appId: appId,
      entryId: entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  setNoRelyCache = (val) => {
    BsyUtils.Store.set(this.getNoRelyCacheKey(), val);
  };

  getNoRelyCache = () => {
    const { ignoreAuth } = this.state;
    if (!ignoreAuth) {
      return false;
    }

    return BsyUtils.Store.get(this.getNoRelyCacheKey()) || false;
  };

  getSearchCacheKey = () => {
    const { appId, entryId, authGroupId } = this.state;
    return BsyUtils.Store.getKey("searchValue", {
      appId: appId,
      entryId: entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  setSearchCach = (val) => {
    BsyUtils.Store.set(this.getSearchCacheKey(), val);
  };

  getSearchCach = () => {
    let res = BsyUtils.Store.get(this.getSearchCacheKey());
    if (res) {
      this.search = res;
    }
    this.setSearchCach(null);
  };

  showCombo = (currentTarget) => {
    let that = this;
    // this.getSearchCach();
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: (ref) => {
        return (
          <SearchComboPane
            getContext={(e) => {
              that.searchContext = e;
            }}
            allCount={this.componentContext.state.allCount}
            formItems={this.fields}
            value={this.search}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: 210,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function (e) {
        that.searchFields = that.searchContext.fields;
        that.search = that.searchContext.getValue();
        if (that.search.keywords.length) {
          that.onSearchText();
        }
        that.setSearchCach(that.search);
        return !1;
      },
    });
  };

  onDataFilter = () => {
    let t = [];
    this.filter && (t = t.concat(this.filter));
    return { filter: t, filterMap: this.filterMap, rel: this.rel || "and" };
  };

  getFieldConfig = () => {
    const {
      asyncExportURL,
      url,
      level2Menu,
      selectDatas,
      isCheckAll,
      enableRowEdit,
      quickEdit,
      noRely,
    } = this.state;
    let that = this;
    let c = this.options,
      e = [], //c.showFields
      f = c.showFieldsFilter,
      g = this._getFields(),
      h = this._getShowFields(g, e),
      i = BsyConfig().LimitFields.filter,
      j = [];
    BsyUtils.forEach(g, function (a, b) {
      i.indexOf(b.type) > -1 && j.push(b);
    });
    if (c.hasFlow) {
      j.push({
        id: c.entryId,
        name: "flownode",
        type: "flownode",
        text: React.language("flow.node.current"),
      });
      j.push({
        id: c.entryId,
        name: "flow_chargers",
        type: "flow_chargers",
        text: React.language("flow.charger.current"),
      });
    }

    let k = [];
    f && (k = this._getShowFields(j, f));
    this.showFields = g;
    this.fields = h;
    let l = null;
    if (c.formAttr && "grid-2" === c.formAttr.layout) {
      l = {};
      BsyUtils.forEach(c.formItems, function (a, b) {
        l[b.widget.widgetName] = b.lineWidth;
      });
    }

    if (c.dataPerms.flow_delete) c.dataPerms.delete = c.dataPerms.flow_delete;
    if (c.dataPerms.flow_update) c.dataPerms.update = c.dataPerms.flow_update;
    if (c.dataPerms.flow_create) c.dataPerms.create = c.dataPerms.flow_create;
    let m = {};
    BsyUtils.forEach(c.showFieldsMeta, function (a, b) {
      let c = a;
      b.subform && (c = [b.subform, a].join("."));
      m[c] = b;
    });

    c.ptlist = [];
    if (!!c.ignoreAuth) {
      c.ptlist = window.FX.STATIC.ptlist ? window.FX.STATIC.ptlist : [];
    } else {
      BsyUtils.forEach(c.printId, function (a1, b1) {
        c.ptlist.push({
          printId: b1.id,
          name: b1.name,
        });
      });
    }

    let config = {
      url,
      asyncExportURL,
      ignoreOptAuth: !!c.ignoreOptAuth,
      ignoreValidate: !!c.ignoreValidate,
      ignoreAuth: !!c.ignoreAuth,
      noRely: noRely && !!c.ignoreAuth,
      optAuth: c.optAuth,
      entryId: c.entryId,
      // formId: c.formId || c.entryId,
      appId: c.appId,
      ptlist: c.ptlist,
      originPrint: c.originPrint,
      dataPerms: c.dataPerms,
      multiTabs: c.formTabs,
      formTabsStyle: c.formTabsStyle || {},
      formItems: c.formItems,
      itemEditable: c.dataPerms.update !== !1,
      itemRemovable: c.dataPerms.delete !== !1,
      itemPrintable: !0, //c.dataPerms.batch_print !== !1,      2020 04 18 统一移动端pc端的数据访问的逻辑打印的逻辑r
      itemLog: c.dataPerms.log === !0,
      itemComment: c.dataPerms.comment === !0,
      flow_activate: c.hasFlow && c.dataPerms.flow_activate === !0,
      flow_close: c.hasFlow && c.dataPerms.flow_close === !0,
      flow_transfer: c.hasFlow && c.dataPerms.flow_transfer === !0,
      flow_log: c.hasFlow && c.dataPerms.flow_log === !0,
      resizable: !0,
      isEtlTable: c.isEtlTable,
      showFieldsMeta: m,
      exportable: !1,
      formLayout: l,
      availableParamFields: j,
      hasFlow: c.hasFlow,
      height4Head: 40,
      width: "100%",
      height: "100%",
      title: c.formName,
      visible4Title: !1,
      fields: h,
      showFields: this.showFields,
      forms: [c.entryId],
      authGroupId: c.authGroupId,
      printId: c.printId,
      widgetId: this.props.widgetId || "form-visit" + c.entryId,
      jsplatform: "React",
      autoHeight: "low",
      enableRowEdit: enableRowEdit,
      quickEdit: quickEdit,
      sortIncludedField: [...BsyConfig().LimitFields.dashSort, "user", "dept"],
      onCloseFlow: (a, b) => {
        BsyAlert({
          title: React.language("flow.close"),
          msg: React.language("flow.close.tip"),
          type: "warning",
          text4Ok: React.language("ok"),
          OkType: "blue",
          text4Cancel: React.language("cancel"),
          ok: () => {
            const { appId, entryId, authGroupId } = this.state;
            let n = {
              appId: appId,
              entryId: entryId,
              formId: entryId,
              dataId: a,
              authGroupId: authGroupId,
              popupFormPath: [],
              extDashData: this.props.extDashData,
            };

            let layerRef = null;
            BsyMaskLayer({
              customCls: "sloading",
              onContentCreate: (ref) => {
                layerRef = ref;
                return (
                  <div>
                    <BsySLoading />{" "}
                  </div>
                );
              },
            });

            React.axios("/data/close_flow", n).then((res) => {
              that.componentContext.reload();
              layerRef && layerRef.close();
              b && b();
            });
          },
        });
      },
    };

    //报表查看原数据
    if (c.extDashData) {
      // config.appId = c.extDashData.appId;
      // config.entryId = c.extDashData.entryId;
      // config.widgetId = c.extDashData.widgetId;
      config.extDashData = c.extDashData;
    }
    return config;
  };

  componentDidMount() {
    super.componentDidMount();
    this.componentKey = "table" + this.renderIndex++;
    this.setState({
      noRely: this.getNoRelyCache(),
    });
  }

  createBody = (config) => {
    const {
      asyncExportURL,
      url,
      level2Menu,
      selectDatas,
      isCheckAll,
      enableRowEdit,
      is_dock_form,
    } = this.state;
    let that = this;

    return (
      <div className="bsy-data-manage-block-body">
        <BsyDataTable
          {...config}
          skip={this.skip || 0}
          hasCount={false}
          getContext={this.getContext}
          level2Menu={level2Menu}
          key={this.componentKey}
          selectDataId={selectDatas}
          isCheckAll={isCheckAll}
          onDataFilter={this.onDataFilter}
          is_dock_form={is_dock_form}
          onReload={() => {
            // 切换可显示字段的时候，会引起样式BUG 需要整个div刷新 2022 06 13 波波
            this.componentKey = "table" + this.renderIndex++;
            this.skip = this.componentContext.state.skip;

            this.setState({}, () => {
              this.onSearchText();
            });

            // this.setState({search: this.search}, () => {
            //   // this.componentContext.loadWidget(null, null, this.skip);
            // })
          }}
          onCheckRow={(dataIds, rowIndex) => {
            // console.log('onCheckRow', JSON.stringify(dataIds))
            // console.log('onCheckRow1', JSON.stringify([...dataIds]))
            this.selectDatas = [...dataIds];
            this.setState(
              {
                selectDatas: [...dataIds],
              },
              () => {
                // console.log('onCheckRow2', JSON.stringify(this.state.selectDatas))
              }
            );
          }}
          //考虑某些情况要对 多选择组件判断显示或者隐藏
          onCheckHook={(rowData) => {
            switch (this.state.batchType) {
              case "transfer": {
                let tip = "";
                if (rowData.hasOwnProperty("flowState")) {
                  if (rowData.flowState === undefined) {
                    tip = "当前数据不是的流程";
                  } else {
                    if (rowData.flowState === 1 || rowData.flowState === 2) {
                      tip = "当前流程数据已经结束";
                    } else {
                      return true;
                    }
                  }
                } else {
                  tip = "当前数据不是的流程";
                }
                return (
                  <div
                    title={tip}
                    style={{
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                  >
                    {" "}
                  </div>
                );
              }

              case "flowend": {
                let tip = "";
                if (rowData.hasOwnProperty("flowState")) {
                  if (rowData.flowState === undefined) {
                    tip = "当前数据不是的流程";
                  } else {
                    if (rowData.flowState === 1 || rowData.flowState === 2) {
                      tip = "当前流程数据已经结束";
                    } else {
                      return true;
                    }
                  }
                } else {
                  tip = "当前数据不是的流程";
                }
                return (
                  <div
                    title={tip}
                    style={{
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                  >
                    {" "}
                  </div>
                );
              }
              default:
                return true;
            }
          }}
        />
      </div>
    );
  };
  render() {
    const { filterSticky, filterTopSticky } = this.state;

    let config = this.getFieldConfig();
    return (
      <div
        className={
          "bsy-data-manage " +
          (filterSticky
            ? "filter-sticky"
            : filterTopSticky
            ? "filter-top-sticky"
            : "")
        }
        style={{
          height: "100%",
          width: "100%",
        }}
        ref={this.element}
      >
        {filterTopSticky ? (
          this.props.hasFilter ? (
            <BsyFilterPane {...this.getFilterConfig()} hasSticky={true} />
          ) : (
            ""
          )
        ) : (
          ""
        )}
        <div
          className="mamge-body"
          ref={this.bodyRef}
          style={{
            height: "calc(100% - 20px)",
          }}
        >
          {this.createHeader()}
          {this.createBody(config)}
        </div>
        {filterSticky ? (
          this.props.hasFilter ? (
            <BsyFilterPane {...this.getFilterConfig()} hasSticky={true} />
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    );
  }
}

export class SearchComboPane extends BsyWidget {
  constructor(props) {
    super({
      minWidth: 100,
      baseCls: "bsy-search-field-pane",
      ...props,
    });

    this.maxFieldsCount = 10;
    this.getFields();

    let value = props.value;

    if (props.allCount > 10000) {
      if (value.isSearchAllFields == true) {
        value.isSearchAllFields = false;

        let n = 5;
        if (value.fields.indexOf("label") > -1) {
          n = 6;
        }

        if (value.fields.length == 0) {
          n = 6;
        }

        BsyUtils.forEach(this.fields, (a1, b1) => {
          if (value.fields.length >= n) {
            return false;
          }
          if (value.fields.indexOf(b1.name) == -1) {
            value.fields.push(b1.name);
          }
        });
      }
    }

    this.state = {
      value: value,
      showField: false,
      disable: false,
      allCount: props.allCount,
    };
  }

  onSearchFields = (key) => {
    this.seachKey = key;
    this.getFields();
    this.setState({});
  };

  filterFields = (obj) => {
    if (obj.name == "_id") {
      return;
    }

    if (this.seachKey) {
      if (obj.text.indexOf(this.seachKey) > -1) {
        this.fields.push(obj);
      }
    } else {
      this.fields.push(obj);
    }
  };

  getFields = () => {
    //单行文本、多行文本、数字、单选按钮组、复选框组、下拉框、下拉复选框，地址，流水号
    let includeFieldsType = [
      "text",
      "textarea",
      "number",
      "radiogroup",
      "combo",
      "sn",
      "checkboxgroup",
      "combocheck",
      "address",
    ];
    let that = this;
    this.fields = [];

    BsyUtils.forEach(this.options.formItems, (index, data) => {
      if (data.type == "subform") {
        BsyUtils.forEach(data.items, (index1, data1) => {
          if (includeFieldsType.indexOf(data1.type) == -1) {
            return;
          }

          let name = [data.name, data1.name].join(".");
          let text = [data.text || data.title, data1.text || data1.title].join(
            "."
          );
          that.filterFields({
            name: name,
            text: text,
          });
        });
      } else {
        if (includeFieldsType.indexOf(data.type) == -1) {
          return;
        }

        that.filterFields(data);
      }
    });
  };

  _doItemClick = (val) => {
    const { value } = this.state;
    let newValue = [];
    if (Array.isArray(value.fields)) {
      newValue = [...value.fields];
    }

    let p = newValue.indexOf(val.name);
    if (p > -1) {
      newValue.splice(p, 1);
    } else {
      newValue.push(val.name);
    }

    let isSearchAllFields = value.isSearchAllFields;
    if (newValue.length) {
      isSearchAllFields = false;
    }

    let disable = false;
    let n = newValue.length;
    if (newValue.indexOf("label") > -1) {
      n = n - 1;
    }
    if (n >= this.maxFieldsCount) {
      disable = true;
    }

    this.setState({
      disable: disable,
      value: {
        ...value,
        fields: newValue,
        isSearchAllFields: isSearchAllFields,
      },
    });
  };

  getValue = () => {
    return this.state.value;
  };

  render() {
    const { cssName, allCount } = this.options;
    const { fields } = this;
    const { value, disable } = this.state;

    return (
      <div className={cssName}>
        {allCount > 10000 ? (
          ""
        ) : (
          <div
            className={
              "range-item " + (value.isSearchAllFields ? " selected" : "")
            }
            onClick={() => {
              this.setState({
                showField: false,
                value: { ...value, isSearchAllFields: true, fields: [] },
              });
            }}
          >
            <span>{React.language("search.all")}</span>
            <i className="icon-ok"></i>
          </div>
        )}

        <div
          className={"range-item "}
          onClick={() => {
            this.setState({ showField: !this.state.showField });
          }}
        >
          <span>{React.language("search.field")} </span>
          <i
            className={"icon-bsy-xia"}
            style={{
              transform: this.state.showField ? "rotate(180deg)" : "",
            }}
          ></i>
        </div>

        {!value.isSearchAllFields ||
        this.state.showField ||
        allCount > 10000 ? (
          <>
            <BsySearchInput
              placeholder={React.language("search.data")}
              // styleInput={{
              //   'width': '200px'
              // }}
              onSearch={this.onSearchFields}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
            ></BsySearchInput>
            {fields.length > 0 ? (
              fields.map((item, index) => {
                const element = { ...item };
                return (
                  <div
                    className={
                      "bsy-group-item bsy-check " +
                      (Array.isArray(value.fields) &&
                      value.fields.indexOf(element.name) > -1
                        ? " select"
                        : element.name != "label" && disable
                        ? " disable "
                        : "")
                    }
                    // key={element.name}
                    onClick={(e) => {
                      e.stopPropagation();
                      this._doItemClick(element);
                    }}
                    title={element.text}
                  >
                    <i className="icon-bsy-check2"></i>
                    <span>{element.text}</span>
                  </div>
                );
              })
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
